import React from 'react'
import FormNotification from '@/component/Primitive/FormNotification'

const isError = (error) =>
  (error && Object.keys(error).length > 0) || error instanceof Error

const showNotification = (message, singleLine, isSuccess) => (
  <FormNotification
    statement={message}
    singleLine={singleLine}
    isSuccess={isSuccess}
  />
)

const defaultServerErrorMessage =
  'Sorry, something went wrong. Please try again later.'

const defaultValidationErrorMessage = 'Please check below and try again.'

export {
  isError,
  showNotification,
  defaultServerErrorMessage,
  defaultValidationErrorMessage
}
